export const ecoType = Object.freeze({"supereco":0, "boost":1, "eco":2})